import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function TestimonialsPage() {
  const testimonials = [
    {
      name: 'Michael Rodriguez',
      location: 'Miami, FL',
      rating: 5,
      platform: 'Google',
      image:
        'https://public.readdy.ai/ai/img_res/4f8d033f12bb5c80b994c128da1066d0.jpg',
      text: "Switching to solar and upgrading our HVAC cut our energy bills by 55%! The team was professional, and the savings calculator was spot-on accurate. Best home investment we've ever made.",
      service: 'Solar + HVAC',
    },
    {
      name: 'Sarah Johnson',
      location: 'Tampa, FL',
      rating: 5,
      platform: 'Google',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20middle-aged%20woman%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-sarah-001&orientation=squarish',
      text: 'Outstanding service from start to finish. Our new heat pump is incredibly efficient and quiet. The installation crew was respectful and cleaned up perfectly. Highly recommend!',
      service: 'Heat Pump Installation',
    },
    {
      name: 'David Chen',
      location: 'Orlando, FL',
      rating: 5,
      platform: 'Trustpilot',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20middle-aged%20Asian%20man%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-david-001&orientation=squarish',
      text: "The attic insulation made a huge difference. Our home stays cooler and our AC doesn't run as much. Great ROI! The solar attic fan was a game-changer too.",
      service: 'Insulation + Solar Fan',
    },
    {
      name: 'Jennifer Martinez',
      location: 'Jacksonville, FL',
      rating: 5,
      platform: 'BBB',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20middle-aged%20woman%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-jennifer-001&orientation=squarish',
      text: "Professional installation, fair pricing, and excellent customer service. They helped us maximize all available rebates and the financing was easy. Couldn't be happier!",
      service: 'Complete Package',
    },
    {
      name: 'Robert Williams',
      location: 'Fort Lauderdale, FL',
      rating: 5,
      platform: 'Google',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20senior%20man%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-robert-001&orientation=squarish',
      text: "We've had our solar system for 6 months now and our electric bills are almost zero! The Premium Protection Plan gives us peace of mind. Excellent investment for retirement.",
      service: 'Solar Installation',
    },
    {
      name: 'Lisa Thompson',
      location: 'St. Petersburg, FL',
      rating: 5,
      platform: 'Trustpilot',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20middle-aged%20woman%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-lisa-001&orientation=squarish',
      text: 'The team was knowledgeable and patient with all our questions. They customized a solution perfect for our home. Our energy costs dropped 48% in the first month!',
      service: 'HVAC + Insulation',
    },
    {
      name: 'James Anderson',
      location: 'Clearwater, FL',
      rating: 5,
      platform: 'Google',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20middle-aged%20man%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-james-001&orientation=squarish',
      text: 'From consultation to installation, everything was seamless. The solar attic fan keeps our attic 30 degrees cooler. Worth every penny!',
      service: 'Solar Attic Fan',
    },
    {
      name: 'Maria Garcia',
      location: 'Naples, FL',
      rating: 5,
      platform: 'BBB',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20middle-aged%20Hispanic%20woman%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-maria-001&orientation=squarish',
      text: "Best decision we made for our home! The financing options made it affordable, and we're already seeing the savings. The crew was professional and efficient.",
      service: 'Complete Package',
    },
    {
      name: 'Thomas Brown',
      location: 'Sarasota, FL',
      rating: 5,
      platform: 'Trustpilot',
      image:
        'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20happy%20senior%20man%20homeowner%20in%20front%20of%20modern%20Florida%20home%2C%20smiling%20confident%20person%2C%20natural%20outdoor%20lighting%2C%20professional%20photography%2C%20warm%20friendly%20atmosphere&width=400&height=400&seq=testimonial-thomas-001&orientation=squarish',
      text: 'Exceptional service! They handled all the permits and rebate paperwork. Our new heat pump is so much better than our old AC. House is comfortable year-round now.',
      service: 'Heat Pump Installation',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="pt-28 pb-16 relative overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20Florida%20sunset%20sky%20with%20warm%20orange%20and%20golden%20tones%20over%20residential%20rooftops%20with%20solar%20panels%2C%20soft%20gradient%20sky%2C%20professional%20photography%2C%20wide%20angle%20panoramic%20view%2C%20warm%20inviting%20atmosphere%2C%20clean%20modern%20aesthetic&width=1400&height=600&seq=testimonials-hero-bg-01&orientation=landscape"
            alt="Florida homes background"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-white"></div>
        </div>
        <div className="max-w-[1400px] mx-auto px-6 relative z-10">
          <div className="text-center mb-12">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-6 font-medium"
            >
              <i className="ri-arrow-left-line"></i>
              Back to Home
            </Link>
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Customer Success Stories
            </h1>
            <p className="text-xl text-white/80 max-w-2xl mx-auto">
              See why hundreds of Florida homeowners trust us with their energy efficiency
              needs
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="flex justify-center mb-4">
                <img src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_42x14dp.png" alt="Google" className="h-7 w-auto" />
              </div>
              <div className="flex justify-center text-brand-gold text-2xl mb-3">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">4.9/5</div>
              <div className="text-gray-600">Google Reviews</div>
              <div className="text-sm text-gray-500 mt-2">Based on 250+ reviews</div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="flex justify-center items-center gap-2 mb-4">
                <svg viewBox="0 0 24 24" className="w-8 h-8 flex-shrink-0" fill="none">
                  <path d="M12 1.5l3.09 6.26L22 8.64l-5 4.87 1.18 6.88L12 17.27l-6.18 3.25L7 13.64 2 8.77l6.91-1.01L12 1.5z" fill="#00B67A"/>
                </svg>
                <span className="text-xl font-bold text-[#00B67A]">Trustpilot</span>
              </div>
              <div className="flex justify-center text-[#00B67A] text-2xl mb-3">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">4.8/5</div>
              <div className="text-gray-600">Trustpilot</div>
              <div className="text-sm text-gray-500 mt-2">Based on 180+ reviews</div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="flex justify-center mb-4">
                <svg viewBox="0 0 120 50" className="w-24 h-10 flex-shrink-0">
                  <rect width="120" height="50" rx="6" fill="#005A78"/>
                  <text x="12" y="30" fontFamily="Arial,sans-serif" fontWeight="bold" fontSize="16" fill="white">BBB</text>
                  <rect x="72" y="7" width="38" height="36" rx="4" fill="#E8A723"/>
                  <text x="80" y="32" fontFamily="Arial,sans-serif" fontWeight="bold" fontSize="22" fill="white">A+</text>
                </svg>
              </div>
              <div className="flex justify-center text-brand-gold text-2xl mb-3">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">A+</div>
              <div className="text-gray-600">BBB Rating</div>
              <div className="text-sm text-gray-500 mt-2">Accredited Business</div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <div
                key={testimonial.name + testimonial.location}
                className="bg-brand-cream rounded-2xl p-8 hover:shadow-xl transition-all duration-300"
              >
                <div className="flex items-start gap-4 mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full object-cover object-top"
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src =
                        'https://via.placeholder.com/64?text=No+Image';
                    }}
                  />
                  <div className="flex-1">
                    <h3 className="font-bold text-gray-900 mb-1">{testimonial.name}</h3>
                    <p className="text-sm text-gray-600 mb-2">{testimonial.location}</p>
                    <div className="flex items-center gap-2">
                      <div className="flex text-yellow-400 text-sm">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <i key={i} className="ri-star-fill"></i>
                        ))}
                      </div>
                      <span className="text-xs text-gray-600">{testimonial.platform}</span>
                    </div>
                  </div>
                </div>
                <p className="text-gray-700 mb-4 leading-relaxed">
                  &ldquo;{testimonial.text}&rdquo;
                </p>
                {/* Use a solid background with opacity instead of the slash‑syntax which can confuse the parser */}
                <div className="inline-block bg-brand-red-light text-brand-red px-3 py-1 rounded-full text-xs font-semibold">
                  {testimonial.service}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-br from-brand-navy to-brand-navy-dark">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready To Join Our Happy Customers?
          </h2>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Get your free home assessment and start saving today
          </p>
          <a
            href="tel:+18005551234"
            className="inline-flex items-center gap-3 bg-brand-red text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-brand-red-dark transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Schedule Free Consultation
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
